export default __webpack_public_path__ + "static/media/Poppins-BoldItalic.759f322b.ttf";